import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../infrastructure/service/api.service';
import {
  BillingCheckoutRequest,
  BillingCheckoutResponse,
  BillingMySubscriptionSummary,
  BillingPlanCatalogItem,
  BillingPlanChangeRequest,
  BillingPlanChangeResponse
} from '../../modules/user-tenant-settings/domain/my-subscription';

@Injectable({
  providedIn: 'root'
})
export class PlanBillingService extends ApiService {

  private serviceUrl = 'billing';

  constructor(http: HttpClient) {
    super(http);
  }

  getCatalog(couponCode?: string): Promise<BillingPlanCatalogItem[]> {
    const query = couponCode ? `?couponCode=${encodeURIComponent(couponCode)}` : '';
    return this.get(`${this.serviceUrl}/plans/catalog${query}`).toPromise();
  }

  getMySubscription(): Promise<BillingMySubscriptionSummary> {
    return this.get(`${this.serviceUrl}/my-subscription`).toPromise();
  }

  checkout(request: BillingCheckoutRequest): Promise<BillingCheckoutResponse> {
    return this.post(`${this.serviceUrl}/my-subscription/checkout`, request).toPromise();
  }

  scheduleDowngrade(request: BillingPlanChangeRequest): Promise<BillingPlanChangeResponse> {
    return this.post(`${this.serviceUrl}/my-subscription/downgrade`, request).toPromise();
  }

  upgrade(request: BillingPlanChangeRequest): Promise<BillingPlanChangeResponse> {
    return this.post(`${this.serviceUrl}/my-subscription/upgrade`, request).toPromise();
  }

  cancelSubscription(): Promise<BillingPlanChangeResponse> {
    return this.post(`${this.serviceUrl}/my-subscription/cancel`, {}).toPromise();
  }
}
